@if (showHead==true) {
  <app-header></app-header>
}
<router-outlet></router-outlet>
@if (showHead==true) {
  <app-footer></app-footer>
}
<ngx-ui-loader></ngx-ui-loader>
<p-toast key="session"></p-toast>
<p-dialog
  [(visible)]="display"
  [modal]="true"
  [closable]="false"
  [showHeader]="true"
  header="Confirmation"
  styleClass="exportClass1"
  >


  <div class="warning-message">
    <i class="pi pi-exclamation-triangle"></i>
    <span>Session expired. Please log in again to continue.</span>
  </div>
  <div class="dialog-footer-center">
    <button type="button" class="btn btn-primary btnCssExport"
      (click)="onPopupClose()" >
      {{ "ok" | translate }}
    </button>
  </div>
</p-dialog>